const outlets = {
  en: {
    outlets: {
      title: "Title",
      url: "URL",
      add_outlet_header: "Add Outlet",
      multi_select: "Select Outlets",
      unknown_user: "Unknown User",
      page_title : {
        create: "Create Outlet",
        edit: "Edit Outlet"
      },
      cbs_auto: {
        title: "CBS Automated Configuration",
        tooltip: "Applying an inclusion timeframe to CBS Automated will allow matching 'hits' only within the selected times.\nPlease note: time ranges cannot cross each other. If they touch, they will be merged when you save. You cannot include more than 23:59 in one day.\nA hit is included if the sentence start or end is within the inclusion timeframe.",
        include_timeframes: "Include Timeframes",
        include_timeframes_description: "Enable to allow coverage creation only during specific time ranges. Time is evaluated in UTC.",
        enable_include_timeframes: "Enable Include Timeframes",
        include_timeframes_settings: "Include Timeframes Settings",
        timeframe: "Timeframe",
        timeframes: "Timeframes",
        add_timeframe: "Add Timeframe",
        remove_timeframe: "Remove timeframe",
        remove: "Remove",
        start_time: "Start Time (UTC)",
        end_time: "End Time (UTC)",
        no_timeframes: "No include timeframes configured. Click 'Add Timeframe' to add one.",
        error_invalid_timeframe: "Start time and end time cannot be the same.",
        error_overlapping_timeframe: "This timeframe overlaps with Timeframe {other}.",
        error_exceeds_24_hours: "Total included time cannot exceed 24 hours.",
        error_validation_failed: "Please fix validation errors before saving.",
        save_success: "CBS Auto configuration saved successfully.",
        save_error: "Failed to save CBS Auto configuration. Please try again.",
        view_audits: "View Audit History",
        audits: {
          title: "CBS Auto Audit History"
        }
      },
      media_type: {
        title: "Media Type",
        select: "Select a Media Type...",
        multi_select: "Select Media Types"
      },
      country: {
        title: "Country",
        select: "Select a Country...",
        multi_select: "Select Countries"
      },
      region: {
        title: "Region",
        select: "Select a Region..."
      },
      language: {
        title: "Language",
        select: "Select a Language",
        multi_select: "Select Languages"
      },
      tiers: {
        title: "Tiers",
        select: "Select a Tier",
        multi_select: "Select Tiers"
      },
      media_types: {
        magazine: "Magazine",
        radio: "Radio",
        website: "Website",
        newspaper: "Newspaper",
        social_networks: "Social Networks",
        tv: "TV",
        news:	"News",
        podcast: "Podcast",
        "social-networks": "Social Networks",
        blog: "Blog",
        forum: "Forum"
      },
      model: {
        loading_error: "Outlet didn't load, please try again"
      },
      modal: {
        help_modal: {
          title: "Outlet Help",
        }
      },
      form: {
        titles: {
          generic: 'Generic',
          location: 'Location',
          audience_metadata: 'Audience Metadata',
          classification: 'Classification',
          aliases: 'Aliases',
          paywall: 'Paywall',
          broadcast: 'Broadcast',
          outlet_translation_name: 'Outlet Translation Name'
        },
        actions: {
          success_message: 'Outlet saved successfully.',
          error_message: 'Outlet not saved. Please try again.',
          delete_success_message: 'Outlet deleted successfully.',
          delete_error_message: 'Outlet not deleted. Please try again.',
        },
        buttons: {
          save: 'Save',
          add: 'Add',
          reset: 'Reset',
          cancel: 'Cancel',
          delete: 'Delete'
        },
        url: 'URL',
        name: 'Name',
        original_name: 'Original Name',
        languages: 'Languages',
        languages_placeholder: 'Select Language(s)',
        uid: 'Bodhi ID',
        active: 'Active',
        article_count: 'Article Count (Previous Month)',
        feeds_info: 'Feed',
        mozrank: 'Domain Authority',
        description: 'Description',
        publisher_id: 'Publisher',
        publisher_id_placeholder: 'Select Publisher',
        licensing_agency_id: 'Licensing Agency',
        licensing_agency_id_placeholder: 'Select Licensing Agency',
        licensing_required: 'Licensing Required',
        smart_summary: 'Smart Summary',
        smart_summary_tooltip: 'Smart Summary Toggle (Outlet Level): Controls whether AI-generated summaries are allowed, governed by project-level compliance settings.',
        enable_auto_release: 'MT Auto Release',
        outlet_provider_id: 'Provider',
        outlet_provider_id_placeholder: 'Select Provider',
        media_subtype: 'Media Type',
        media_subtype_placeholder: 'Select Media Type',
        frequency: 'Frequency',
        frequency_placeholder: 'Select Frequency',
        outlet_sector_id: "Sector",
        outlet_sector_id_placeholder: "Select Sector",
        outlet_category_id: "Segment",
        outlet_category_id_placeholder: "Select Segment",
        priority_level: "Priority",
        priority_level_placeholder: "Select Priority",
        carma_ocr_provider: "Carma OCR Provider",
        carma_ocr_provider_placeholder: "Select Carma OCR Provider",
        global_region_id: "Global Region",
        global_region_id_placeholder: "Select Global Region",
        location_id: "Country",
        location_id_placeholder: "Select Country",
        address: "Address",
        county_id: "State/Province/County",
        county_id_placeholder: "Select",
        city: "City",
        scope_type: "Scope Type",
        scope_type_placeholder: "Select Scope Type",
        quality_assurance_date: "Quality Assurance Date",
        name_aliases: "Name Aliases",
        url_aliases: "Url Aliases",
        nla_alias: "NLA Alias",
        media_track_english_alias: "Media Track English Alias",
        media_track_portuguese_alias: "Media Track Portuguese Alias",
        media_track_asian_alias: "Media Track Asian Alias",
        media_track_arabic_alias: "Media Track Arabic Alias",
        media_track_french_alias: "Media Track French Alias",
        media_track_iran_alias: "Media Track Iran Alias",
        media_track_hebrew_alias: "Media Track Hebrew Alias",
        media_track_broadcast_alias: "Media Track Broadcast Alias",
        tveyes_alias: "TVEyes Alias",
        tveyes_podcast_alias: "TVEyes Podcast Alias",
        channel: 'Channel',
        genres: 'Genres',
        genres_placeholder: 'Select Genre',
        airtime: 'Airtime',
        paywall: "Paywall",
        paywall_label: "Paywall",
        paywall_placeholder: "Select Paywall",
        active_subscription: "Active Subscription",
        subscription_expire_date: "Subscription Expiry Date",
        access_office_id: "Access Office",
        access_office_id_placeholder: "Select Access Office",
        projects: "Projects",
        projects_placeholder: "Search or Add project",
        paywall_cost_in_usd: "Annual Paywall Cost USD",
        original_paywall_cost: "Original Paywall Cost",
        original_currency: "Original Currency",
        original_currency_placeholder: "Select Original Currency",
        payment_interval: "Payment Interval",
        payment_interval_placeholder: "Select Payment Interval",
        last_cost_checked_date: "Last Cost Checked Date",
        login_data: "Login Data",
        paywall_remarks: "Paywall Remarks",
        paywall_e_edition: "E-Edition",
        add_alias: "Add Alias",
        reviewed: "Reviewed",
        publish_on_mediadb: "Publish on MediaDB",
        translation_language: 'Outlet Name Translation Language',
        translation_name: 'Outlet Name Translation',
        autoremove_manual_content: 'Auto Text/Asset Remove',
        autoremove_manual_content_tooltip: 'Automatically removes full text and assets based on media type: Manually uploaded print content/assets are removed after 28 days, while online full text is restricted from the publication date.'
      }
    }
  }
}

module.exports.outlets = outlets;